/* Kay delivery estimate for the cart drawer DHL bar */
(function () {
  var CONFIG = {
    TARGET_SELECTOR: '.kay-dhl__text',
    TIMEZONE: 'Europe/Berlin',
    CUTOFF_HOUR: 12,
    CUTOFF_MINUTE: 30,
    LABEL: 'Kostenlose Lieferung',
    TOMORROW: 'Morgen',
    TEXT_NOW: 'Wenn Sie jetzt bestellen',
    SHOW_COUNTDOWN: false,
    TEXT_COUNTDOWN: function (h, m) {
      return 'Bei Bestellung innerhalb von ' + h + ' Std. und ' + m + ' Min.';
    },
    LOCALE: 'de-DE',
    EXTRA_HOLIDAYS: [],
    EXTRA_EASTER_OFFSETS: []
  };

  var DAY_MS = 86400000;
  var holidayCache = {};

  function easterSunday(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, month - 1, day);
  }

  function holidaysFor(y) {
    if (holidayCache[y]) return holidayCache[y];
    var easter = easterSunday(y);
    var list = [
      Date.UTC(y, 0, 1), easter - 2 * DAY_MS, easter + 1 * DAY_MS,
      Date.UTC(y, 4, 1), easter + 39 * DAY_MS, easter + 50 * DAY_MS,
      Date.UTC(y, 9, 3), Date.UTC(y, 11, 25), Date.UTC(y, 11, 26)
    ];
    CONFIG.EXTRA_HOLIDAYS.forEach(function (s) {
      var p = s.split('-');
      list.push(Date.UTC(y, +p[0] - 1, +p[1]));
    });
    CONFIG.EXTRA_EASTER_OFFSETS.forEach(function (n) { list.push(easter + n * DAY_MS); });
    var set = {};
    list.forEach(function (t) { set[t] = true; });
    holidayCache[y] = set;
    return set;
  }

  function isHoliday(ts) { return !!holidaysFor(new Date(ts).getUTCFullYear())[ts]; }
  function isShippingDay(ts) {
    var dow = new Date(ts).getUTCDay();
    return dow >= 1 && dow <= 5 && !isHoliday(ts);
  }
  function isDeliveryDay(ts) { return new Date(ts).getUTCDay() !== 0 && !isHoliday(ts); }

  function berlinNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: CONFIG.TIMEZONE, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return {
      today: Date.UTC(+o.year, +o.month - 1, +o.day),
      minutesOfDay: (+o.hour % 24) * 60 + +o.minute
    };
  }

  function formatDay(ts) {
    return new Date(ts).toLocaleDateString(CONFIG.LOCALE, { weekday: 'long', timeZone: 'UTC' });
  }

  function update() {
    var els = document.querySelectorAll(CONFIG.TARGET_SELECTOR);
    if (!els.length) return;

    var now = berlinNow();
    var cutoff = CONFIG.CUTOFF_HOUR * 60 + CONFIG.CUTOFF_MINUTE;

    var ship = now.today;
    var shipsToday = isShippingDay(ship) && now.minutesOfDay < cutoff;
    if (!shipsToday) {
      ship += DAY_MS;
      while (!isShippingDay(ship)) ship += DAY_MS;
    }

    var delivery = ship + DAY_MS;
    while (!isDeliveryDay(delivery)) delivery += DAY_MS;

    var label = delivery === now.today + DAY_MS ? CONFIG.TOMORROW : formatDay(delivery);
    var text = CONFIG.TEXT_NOW;
    if (shipsToday && CONFIG.SHOW_COUNTDOWN) {
      var rem = cutoff - now.minutesOfDay;
      text = CONFIG.TEXT_COUNTDOWN(Math.floor(rem / 60), rem % 60);
    }

    var html = '<strong>' + CONFIG.LABEL + ': ' + label + '</strong> - ' + text + '.';
    for (var i = 0; i < els.length; i++) {
      if (els[i].innerHTML !== html) els[i].innerHTML = html;
      els[i].setAttribute('data-kay-done', '1');
    }
  }

  function start() {
    update();
    setInterval(update, 60000);
    // the cart drawer is re-rendered by ajax, so fill new bars right away
    if (window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          if (document.querySelector(CONFIG.TARGET_SELECTOR + ':not([data-kay-done])')) update();
        }, 50);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();